module.exports = __webpack_public_path__ + "img/marca3.843ecd6d.jpeg";